module.exports = IMask;